export default __webpack_public_path__ + "static/media/cp_geo_er.31a06190.svg";